import React from "react"
import { enableAllFilters } from "../models/FilterState"

interface ColumnFilterProps {
  filters
  setFilters
  fields
  label
}

const MultiColumnFilter = (props: ColumnFilterProps) => {
  let { filters, setFilters, fields, label } = props
  return (
    <button className="button small less-important" onClick={() => setFilters(enableAllFilters(filters, fields))}>
      {label}
    </button>
  )
}

export default MultiColumnFilter
